const absCount = (count) => Math.abs(Math.trunc(Number(count) || 0));

/** 2–4, 22–24, … but not 12–14. */
export const isPolishFew = (count) => {
  const n = absCount(count);
  const teen = n % 100;
  if (teen >= 12 && teen <= 14) return false;
  const last = n % 10;
  return last >= 2 && last <= 4;
};

/** Accusative: Pobyt za N, Łącznie za N, × N. */
export const personAccusative = (count) => {
  const n = absCount(count);
  if (n === 1) return 'osobę';
  return isPolishFew(n) ? 'osoby' : 'osób';
};

/** Genitive after "pobyt": 1 osoby, every other count osób. */
export const personStayGenitive = (count) => (absCount(count) === 1 ? 'osoby' : 'osób');

/** Locative: przy N osobie / osobach. */
export const personLocative = (count) => (absCount(count) === 1 ? 'osobie' : 'osobach');

export const adultWord = (count) => (absCount(count) === 1 ? 'dorosły' : 'dorosłych');

export const childWord = (count) => (absCount(count) === 1 ? 'dziecko' : 'dzieci');

export const nightWord = (count) => {
  const n = absCount(count);
  if (n === 1) return 'noc';
  return isPolishFew(n) ? 'noce' : 'nocy';
};

export const nightsLabel = (count) => {
  const n = absCount(count);
  if (n <= 0) return '';
  return `${n} ${nightWord(n)}`;
};

/** „przy 2 osobach dorosłych i 1 dziecku”. */
export const partyBasis = (adults, children = 0) => {
  const a = absCount(adults);
  const c = absCount(children);
  const parts = [];
  if (a === 1) parts.push('1 osobie dorosłej');
  else if (a > 1) parts.push(`${a} osobach dorosłych`);
  if (c === 1) parts.push('1 dziecku');
  else if (c > 1) parts.push(`${c} dzieciach`);
  return parts.length ? `przy ${parts.join(' i ')}` : '';
};

export const guestsLabel = (adults, children = 0, separator = ', ') => {
  const a = absCount(adults);
  const c = absCount(children);
  const parts = [];
  if (a > 0) parts.push(`${a} ${adultWord(a)}`);
  if (c > 0) parts.push(`${c} ${childWord(c)}`);
  return parts.join(separator);
};
